import { logAndylitics, log, logAPI } from "./andyliticsApi";
const BASE_URL = typeof window !== 'undefined' ? window.serverData.data.apiBaseUrl : '';
const CLIENT_ID = "MyBSWHealth.Web";
import * as tools from "../helpers/Tools";

export const getProvidersList = (searchModel, token) => {
    const start = new Date();
    const fullUrl = `${BASE_URL}v2/Epic/GetProvidersList?epicProvidersRequest.loginId=${encodeURIComponent(searchModel.loginId)}&epicProvidersRequest.proxyPatientId=${searchModel.proxyPatientId}&epicProvidersRequest.proxyPatientIdType=EXTERNAL`;
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json",
            "Authorization": `bearer ${token}`
        },
        method: "GET"
    };

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Schedule.Direct.ProvidersList.Get", start, fullUrl);
            if (response && response.status >= 200 && response.status < 300) {
                return Promise.resolve(response.json());
            } else {
                return Promise.reject(response);
            }
        })
        .catch(error => {
            logAPI("MBHWeb.Api.Schedule.Direct.ProvidersList.Get.Failure", start, fullUrl, JSON.stringify(error));
            return Promise.reject(error);
        });
};
